import React from 'react';
import { Image, ArticleHeading2, ArticleParagraph2 } from '@cian/ui-kit';

import styles from './styles.css';

interface IBankTitleProps {
  bankName: string;
  logoUrl: string;
  logoSize?: number | string;
  tags: string[];
}

export const BankTitle: React.FC<IBankTitleProps> = ({ bankName, logoUrl, logoSize = 48, tags }) => {
  return (
    <div className={styles['root']}>
      <div className={styles['logo']}>
        <Image src={logoUrl} alt={bankName} borderRadius={'50%'} width={logoSize} height={logoSize} preloader />
      </div>
      <div>
        <ArticleHeading2>
          <span className={styles['name']}>{bankName}</span>
        </ArticleHeading2>
        <div className={styles['tags']}>
          {tags.map(tag => (
            <div key={tag} className={styles['tag']}>
              <ArticleParagraph2>{tag}</ArticleParagraph2>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
